import { Controller } from "stimulus";

export default class SimpleModalController extends Controller {
  static targets = ["modal"];

  open(e) {
    e.preventDefault();
    if (e.currentTarget.dataset.targetModal) {
      this.modalTargets
        .find(t => t.dataset.modalName === e.currentTarget.dataset.targetModal)
        .classList.remove("hidden");
    } else {
      this.modalTarget.classList.remove("hidden");
    }
  }

  close(e) {
    e.preventDefault();
    this.modalTargets.forEach(t => t.classList.add("hidden"));
  }
}
